var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"text-center"},[_c('p',[_vm._v("Info will be later... ;-)")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }